import { useChainId } from 'wagmi'

import { SupportedChainId } from '@/config/chain/types'
import { SUPPORTED_CHAIN_IDS } from '@/config/chain/constants'

const chainIdToOriginChainIdCache = new Map<number, number>()

export function useOriginChainId(): SupportedChainId {
  const chainId = useChainId()
  const originChainId = getOriginChainId(chainId)
  chainIdToOriginChainIdCache.set(chainId, originChainId)
  return originChainId
}

export function getOriginChainId(chainId: number): SupportedChainId {
  const cached = chainIdToOriginChainIdCache.get(chainId)
  if (cached !== undefined) {
    return cached as SupportedChainId
  }

  const defaultChainId = SUPPORTED_CHAIN_IDS[0] as number
  const isSupported = (SUPPORTED_CHAIN_IDS as number[]).includes(chainId)

  // Always resolve unsupported chains to our default app chain
  return (isSupported ? chainId : defaultChainId) as SupportedChainId
}
